import * as TYPE from '../types';

export const dataOps = (state = [], action) => {
  switch (action.type) {
    case TYPE.UPDATE_DATAOPS:
      const newData = {};
      action.data.forEach(event => {
        newData[event._id] = { ...state[event._id], ...event };
      });
      return newData;
    case TYPE.UPDATE_DATAOPS_EVENT:
      const newSate = { ...state };
      newSate[action.event._id] = { ...action.event };
      return newSate;
    default:
      return state;
  }
};
